export const chartColorMap =
    [
        '#fac858',
        '#ee6666',
        '#73c0de',
        '#5470c6',
        '#91cc75',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
    ];

export const chartTypeMap = {
    bar: 1,
    line: 2,
    pie: 3,
    totalBar: 4,
    totalPercentBar: 5,
};

export const dataTypeMap = {
    tagged: 1,
    statisticsMemberAbout: 2,
    statisticsNonMembership: 3,
    statisticsCoach: 4,
};

export const filterTargetTypeMap = {
    singleClub: 1,
    singleMember: 2,
    singleProduct: 3,

    clubTag: 11,
    memberTag: 12,
    memberDynamicTag: 13,
    memberOrderTag: 14,
    memberMeasureTag: 15,
    memberPurchaseTag: 16,
    memberWorkoutTag: 17,

    // monthlyStatistics:101,
    // monthlyHealthcareStatistics:102,
};

export const filterAxisTypeMap = {
    none: 0,
    club: 1,
    date: 2,
    memberCount: 3,
    coach:4,
    healthcare:5,

    clubTagType: 11,
    memberTagType: 12,
    memberDynamicTagType: 13,
    memberOrderTagType: 14,
    memberMeasureTagType: 15,
    memberPurchaseTagType: 16,
    memberWorkoutTagType: 17,
};

export const filterRangeTypeMap = {
    monthly: 1,
    quarterly: 2,
    yearly: 3,
};

export const statisticsMainGroupTypeMap = {
    membership: 1,
    clubService: 2,
    customerAcquisition: 3,
    nonMembership: 4,
    coach: 5,
};

export const statisticsSubGroupTypeMap = {
    agp: 301,
    calls: 302,
    apo: 303,
    join: 304,
    
    healthcareCycle: 401,
    healthcareBuyout: 402,
    product: 403,
}

